import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://elviynomaexlzzqbdufy.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVsdml5bm9tYWV4bHp6cWJkdWZ5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODczNTk1OTMsImV4cCI6MjEwMjkzNTU5M30.X3htnj3zuurPwUO0zTmeVDyVcIBKPmIahNtTZBISteM';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export async function getSessionFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const access_token = params.get('token');
  if (!access_token) return null;

  try {
    const { data, error } = await supabase.auth.setSession({
      access_token,
      refresh_token: access_token,
    });

    if (error) {
      console.log("Session error:", error.message);
      window.history.replaceState(null, '', window.location.pathname);
      return null;
    }

    window.history.replaceState(null, '', window.location.pathname);
    return data.session;
  } catch (e) {
    console.log("Session catch:", e);
    return null;
  }
}
export async function guardarAnalisis(session, {
  empresa, sector, problema, signals_count,
  foda, horizontes, impacto, plan,
  logica_innovacion, mercados, objetivo, etapa, facturacion, departamento, obstaculo, plazo,
  senales, micmac, sostenibilidad
}) {
  if (!session) return null;

  const { data, error } = await supabase
    .from('projects')
    .insert({
      user_id: session.user.id,
      empresa: empresa || "",
      sector: sector || "",
      problema: problema || "",
      departamento: departamento || "",
      signals_count: signals_count || 0,
      foda: foda ? JSON.stringify(foda) : null,
      micmac: micmac ? JSON.stringify(micmac) : null,
      horizontes: horizontes ? JSON.stringify(horizontes) : null,
      impacto: impacto ? JSON.stringify(impacto) : null,
      senales: senales ? JSON.stringify(senales) : null,
      plan: plan || null,
      logica_innovacion: logica_innovacion || "",
      mercados: mercados || "",
      objetivo: objetivo || "",
      etapa: etapa || "",
      facturacion: facturacion || "",
      obstaculo: obstaculo || "",
      plazo: plazo || "",
      sostenibilidad: sostenibilidad ? JSON.stringify(sostenibilidad) : null,
    })
    .select()
    .single();

  console.log("Resultado guardar:", { data, error });

  if (error) {
    console.error('Error guardando análisis:', error);
    return null;
  }
  return data;
}

export async function signInWithEmail(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  if (error) console.error('Error en login:', error);
  return { data, error };
}

export async function signUpWithEmail(email, password) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
  });
  if (error) console.error('Error en registro:', error);
  return { data, error };
}